import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { PcmsoUpdateRequest } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { SICOM_PATHS } from 'src/sicom-paths';

export interface PutPcmsoParams {
    uf: string;
    idMedico: number | string;
    nuRegistro: number | string;
}

/**
 * Atualiza um registro de PCMSO do Médico (MEDICO_PCMSO)
 * Não altera o anexo (IM_DOCUMENTO). Retorna 204 em caso de sucesso.
 */
export function putPcmso(http: HttpClient, rootUrl: string, params: PutPcmsoParams, body: PcmsoUpdateRequest, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, putPcmso.PATH, 'put');
    rb.path('uf', params.uf, {});
    rb.path('idMedico', params.idMedico, {});
    rb.path('nuRegistro', params.nuRegistro, {});
    rb.body(body, 'application/json');

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r.clone({ body: undefined }) as unknown as StrictHttpResponse<void>;
        })
    );
}

putPcmso.PATH = SICOM_PATHS.registro.medico.pcmso.registro;
